import { useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { StyledBasicTextWithUIGuidelines } from 'component-library/atoms/BasicTextWithUIGuidelines/styles';
import { LinkWithUIGuidelines } from 'component-library/atoms/LinkWithUIGuidelines';
import { ICustomTheme } from 'interfaces';
import { appConfigSelector } from 'reducers/app.reducer';

export default function DataPolicyLabel() {
  const { programUrl, programName, companyName, dataProtectionsPath } =
    useSelector(appConfigSelector);
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const { t } = useTranslation();

  return (
    <StyledBasicTextWithUIGuidelines
      isMobile={isMobile}
      margin={`${theme.spacing(1)}px 0 0 0`}
    >
      {t('auth.signup.dataPolicyOptin', { programName, companyName })}{' '}
      <LinkWithUIGuidelines
        color={theme.colors.paletteFromBO.main}
        fontWeight="bold"
        url={`${programUrl}${dataProtectionsPath}`}
        textLink={t('auth.signup.dataPolicyLink')}
        isInternalLink={false}
        withUnderline
      />
      {'*'}
    </StyledBasicTextWithUIGuidelines>
  );
}
